var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhonetwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "master_svg0_9_900"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#A073FF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7230FF",
    stopOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0.0000457763671875,
    width: 18,
    height: 18,
    rx: 0,
    fill: "#D8D8D8",
    fillOpacity: 1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15,14.8926Q15,15.3317,14.8047,15.709Q14.6089,16.0866,14.2656,16.3765Q13.923,16.6663,13.4629,16.833Q13.0029,16.9999,12.47461,17L5.52539,17Q4.99684,17,4.53711,16.833Q4.0770800000000005,16.6662,3.734375,16.3765Q3.391798,16.0867,3.195312,15.709Q2.999553763,15.3314,3,14.8926L3.000000998378,3.125Q3.000000998378,2.6859200000000003,3.195313,2.2998000000000003Q3.391072,1.913416,3.734376,1.623535Q4.07695,1.333744,4.53711,1.166992Q4.99714,1.000142694,5.52539,1L12.47461,1Q13.0032,1,13.4629,1.166992Q13.9229,1.333842,14.2656,1.623535Q14.6082,1.913327,14.8047,2.2998000000000003Q15.0004,2.68619,15,3.125L15,14.8926ZM13.4141,3.96826L4.56641,3.96826L4.56641,14.0317L13.4141,14.0317L13.4141,3.96826ZM8.99023,14.5234Q8.579139999999999,14.5234,8.27539,14.7871Q7.97196,15.0506,7.97266,15.437Q7.97266,15.8058,8.27539,16.0781Q8.57882,16.3504,8.99023,16.350099999999998Q9.4209,16.350099999999998,9.714839999999999,16.0781Q10.008479999999999,15.8059,10.00781,15.437Q10.00781,15.0506,9.714839999999999,14.7871Q9.42121,14.5237,8.99023,14.5234ZM10.55664,2.4751000000000003Q10.55664,2.33459,10.45801,2.25586Q10.36013,2.17683,10.24317,2.17676L7.75684,2.17676Q7.65896,2.17676,7.55176,2.25586Q7.44409,2.3348899999999997,7.44336,2.4751000000000003Q7.44336,2.6155999999999997,7.54199,2.69482Q7.63987,2.77386,7.75684,2.77393L10.24317,2.77393Q10.36062,2.77393,10.45801,2.69482Q10.55589,2.61579,10.55664,2.4751000000000003Z",
    fill: "url(#master_svg0_9_900)",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonetwo);
export default __webpack_public_path__ + "static/media/phonetwo.fcf2cb53bffe1f7294657c6955043c4a.svg";
export { ForwardRef as ReactComponent };